/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
export const JobOutcomeNextFileObject = core.serialization.object({
    fileId: core.serialization.string(),
    label: core.serialization.string().optional(),
});
